export enum ProgramPaths {
    ofispro = "/ofispro",
    icrapro = "/icrapro",
    eicrapro = "/eicrapro",
    davapro = "/davapro",
    arabulucupro = "/arabulucupro",
    giris = "/giris",
    erisimYok = "/erisim-yok",
    // DEV-2113 — lisans kaynakli engelde kullanici buraya duser. erisim-yok
    // ciplak bir 403 sayfasi; lisans durumunu ve yenileme adimini anlatmiyor.
    lisansDurumu = "/lisans-durumu",
    // DEV-2113 — bu büroda kapalı bir özelliğin adresine gidilince açılır.
    ozellikKapali = "/ozellik-kapali"
}